import { clearBrowserCookies, clearWebStorage } from '@/lib/storage/browserStorage';
import { NEXT_PUBLIC_HUBSPOT_DISABLED } from '@/lib/env';
import logger from './logger';

// `messagesUtk` (chat widget) isn't `hs`-prefixed, so it needs the explicit list; the pattern covers the rest plus any HubSpot-namespaced keys the embed adds later.
const HUBSPOT_COOKIE_NAMES = ['__hstc', 'hubspotutk', '__hssc', '__hssrc', 'messagesUtk'];
const HUBSPOT_KEY_PATTERN = /^(__hs|_hs|hubspot)/i;

/** Whether HubSpot is enabled for this site (env). Consent is checked separately at the call site. */
export const isHubSpotConfigured = (): boolean => !NEXT_PUBLIC_HUBSPOT_DISABLED;

const isHubSpotKey = (name: string): boolean =>
  HUBSPOT_COOKIE_NAMES.includes(name) || HUBSPOT_KEY_PATTERN.test(name);

const clearHubSpotStorage = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const cookiesRemoved = clearBrowserCookies(isHubSpotKey);
  const localRemoved = clearWebStorage(() => window.localStorage, isHubSpotKey);
  const sessionRemoved = clearWebStorage(() => window.sessionStorage, isHubSpotKey);

  logger.debug('Cleared HubSpot storage', { cookiesRemoved, localRemoved, sessionRemoved });
};

/**
 * Clears HubSpot's cookies and storage on Reject/withdraw. An already-loaded embed can't be unloaded without a reload, so this stops collection by clearing storage rather than the script.
 */
export const disableHubSpot = (): void => {
  logger.debug('HubSpot disabled');
  clearHubSpotStorage();
};
